import { Link } from "react-router-dom";

export default function PageHero({ kicker, title, highlight, subtitle, image, breadcrumb, useLogo = false }) {
  return (
    <section
      className="relative bg-[#001B35] text-white overflow-hidden"
      data-testid="page-hero"
    >
      {/* Background */}
      {useLogo ? (
        <div className="absolute inset-0" aria-hidden="true">
          {/* Brand gradient halos */}
          <div className="absolute -top-32 -right-32 w-[680px] h-[680px] bg-[#005BBB] rounded-full blur-3xl opacity-30" />
          <div className="absolute -bottom-32 -left-24 w-[520px] h-[520px] bg-[#D90000] rounded-full blur-3xl opacity-18" />
          {/* Desktop watermark logo on the right — only on large screens (>=1024px) */}
          <div className="absolute inset-y-0 right-0 w-[42%] hidden lg:flex items-center justify-end pr-4 lg:pr-12">
            <img
              src="/logo-rm.jpg"
              alt=""
              className="h-[78%] max-h-[420px] w-auto rounded-3xl object-contain opacity-95 select-none pointer-events-none drop-shadow-2xl"
            />
          </div>
          {/* Strong dark veil on the left so text always stays readable */}
          <div className="absolute inset-0 bg-gradient-to-r from-[#001B35] from-55% via-[#001B35]/80 via-70% to-transparent" />
        </div>
      ) : (
        image && (
          <div className="absolute inset-0">
            <img src={image} alt="" className="w-full h-full object-cover opacity-60" />
            <div className="absolute inset-0 hero-overlay" />
          </div>
        )
      )}

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20 lg:py-28">
        {/* Mobile / tablet visible logo (centered above text) */}
        {useLogo && (
          <div className="flex lg:hidden justify-center mb-8 sm:mb-10 rm-anim" data-testid="page-hero-logo-mobile">
            <div className="relative">
              <div className="absolute inset-0 bg-[#005BBB] rounded-full blur-3xl opacity-30 scale-110" />
              <div className="absolute inset-0 bg-[#D90000] rounded-full blur-3xl opacity-20 scale-90 translate-x-3 translate-y-3" />
              <img
                src="/logo-rm.jpg"
                alt="Logo RM Plomberie Chauffage VMC"
                className="relative w-36 sm:w-44 md:w-52 h-36 sm:h-44 md:h-52 rounded-3xl object-cover ring-4 ring-white/15 shadow-2xl"
              />
            </div>
          </div>
        )}

        {breadcrumb && (
          <p className="text-xs uppercase tracking-[0.2em] text-[#9bb6d6] mb-4" data-testid="page-hero-breadcrumb">
            <Link to="/" className="hover:text-white">Accueil</Link> <span className="mx-2">/</span> <span className="text-white">{breadcrumb}</span>
          </p>
        )}
        {kicker && (
          <p className="text-xs uppercase tracking-[0.24em] font-semibold text-[#005BBB] mb-3 rm-anim">{kicker}</p>
        )}
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold leading-[1.05] max-w-xl md:max-w-2xl rm-anim rm-delay-1" data-testid="page-hero-title">
          {highlight && <span className="text-[#5dade2]">{highlight}</span>}
          {title}
        </h1>
        {subtitle && (
          <p className="mt-6 text-base sm:text-lg text-[#cfdbe8] max-w-lg md:max-w-xl rm-anim rm-delay-2">
            {subtitle}
          </p>
        )}
      </div>
      <div className="absolute bottom-0 left-0 right-0 h-12 bg-gradient-to-t from-white to-transparent" />
    </section>
  );
}
